import Vue from "vue";
import Vuex from "vuex";
import * as constant from '@/store/constant'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		// areaid:'',
		// areaName:'全国',
		// appid: '',
		// bid: '0',
		// sid: '0',
		// backurl: '',
		token:'1111111111',//[{"userTokenKey":"b6f24fb7a86d92ae6f5e9b20cdc3bbe4"}],//JSON.parse(localStorage.getItem('token'))||'', //'eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJqd3QiLCJpYXQiOjE1MTIwNDU0OTEsInN1YiI6IntcImhlYWRpbWdcIjpcImh0dHA6Ly93eC5xbG9nby5jbi9tbW9wZW4vdmlfMzIvUGlhanhTcUJSYUVKb0VjMlJEa2lhdWlhazh4aWNSeXNOdFNpY3FBdHF2aHA5aWNvSGlickRaUDF2Y09jbDBsSzBZRjhCNnduNXg0MUI2aDVuVFdTSThPZGFpY2ljSHcvMFwiLFwidWlkXCI6XCI2M2NiYWEzNDg1MmQ0NDNkYTUzNTJjY2Y2MDIyZWE3M1wifSIsImV4cCI6MTUxMjA0OTA5MX0.3z-o4ijQ256mWzR36gjj44zH6m-RabTYrDSXUf9842A',
        qes:[],
		// user:'',
    	// user: JSON.parse(localStorage.getItem('user'))||{},
		// buss:{
		// 	banner:'http://114.55.2.155:28002/files/0/img/sybj.jpg',
		// 	name:"浙江爵达电子商务公司",
		// 	servisetel:"15512156660"
		// },
		// hide_footer: false,
		// tabname: 'points',
		// goods_scoll: 0,
		// goods_list: {},
		// page_size:7,
		// list:JSON.parse(localStorage.getItem('temp'))||{},
		// userCheck:'未签到'
	},
	mutations: {
		//只能同步的函数
       SET_TOKEN(state, token) {
        	state.token = token;
        },
		SET_QES(state, qes) {
			state.qes = qes;
		},
		// [constant.SET_TOKEN](state, token) {
		// 	state.token = token;
		// },
        // [constant.num](state, num) {
        //     state.num = num;
        // },

		// [constant.SET_USER](state, user) {
		// 	state.user = user;
		// },
		// [constant.SET_BUSS](state, buss) {
		// 	state.buss = buss;
		// },
		// [constant.SET_BID](state, bid) {
		// 	state.bid = bid;
		// },
		// [constant.CLEAN_ALL](state) {
		// 	state.token = '';
		// 	state.user = {};
		// },
		// [constant.SET_BACKURL](state, backurl) {
		// 	state.backurl = backurl;
		// },
		// [constant.SET_AREAID](state, areaid) {
		// 	state.areaid = areaid;
		// },
		// [constant.SET_AREANAME](state, areaName) {
		// 	state.areaName = areaName;
		// },
		// [constant.SET_USERCHECK](state, userCheck) {
		// 	state.userCheck = userCheck;
		// },
		[constant.HIDE_FOOTER](state, hide_footer) {
			state.hide_footer = hide_footer;
		},
		[constant.KEEP_ALIVE](state, keep_alive) {
			state.keep_alive = keep_alive;
		},
		// [constant.TABNAME](state, tabname) {
		// 	state.tabname = tabname;
		// },
		// [constant.SET_SCOLL](state, scoll) {
		// 	state.goods_scoll = scoll;
		// },
		// [constant.SET_GOODS](state, goods) {
		// 	state.goods_list = goods;
		// },
		// [constant.SET_SIZE](state, size) {
		// 	state.page_size = size;
		// },
		// [constant.SET_LIST](state, list) {
		// 	state.list = list;
		// }
	},
	// plugins: [
	// 	createPersistedState({
	// 		storage: window.sessionStorage
	// 	})
	// ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js